import styled from "styled-components";
import { MEDIA_QUERY } from "../../entities/Common";

export const CategoriesCondimentsStyled = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  > div {
    &:first-child {
      width: 300px;
      height: inherit;
    }
    &:last-child {
      width: calc(100% - 310px);
      height: inherit;
    }
  }
  @media (max-width: ${MEDIA_QUERY.LAPTOP}) {
    > div {
      &:first-child {
        width: 200px;
      }
      &:last-child {
        width: calc(100% - 210px);
      }
    }
  }

  @media (max-width: ${MEDIA_QUERY.TABLET_VERTICAL}) {
    > div {
      &:first-child {
        width: 160px;
      }
      &:last-child {
        width: calc(100% - 165px);
      }
    }
  }
  @media (max-width: ${MEDIA_QUERY.MOBILE}) {
    display: block;
    > div {
      &:first-child {
        width: 100%;
      }
      &:last-child {
        width: 100%;
      }
    }
  }
`;
